import React from 'react'

const CardBox = ({ props }) => {
  
    return (
        <div className="msync-stat msync-stat--is-style-card">
            <span className='msync-stat__details'>{props.count ?? 0}</span>
            {props.label && 
                <span className='msync-stat__term'>{props.count === 1 ? (props.labelSingular ? props.labelSingular : props.label) : props.label }</span>
            }
        </div>
    )
}

export default CardBox